// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { WarningStatusIcon } from '@/constants/hardfin-standard-icons';
import { pluralize } from '@/utilities/pluralize';
import { Chip, Skeleton } from '@mui/material';

type NeedsAttentionFilterChipBaseProps = {
  isActive: boolean;
  onClick: () => void;
} & (
  | {
      countStatus: 'loading';
      needsAttentionCount?: never;
    }
  | {
      countStatus: 'loaded';
      needsAttentionCount: number;
    }
);

export function NeedsAttentionFilterChipBase(
  props: NeedsAttentionFilterChipBaseProps
) {
  const hasNeedsAttentionCount =
    props.countStatus === 'loaded' && props.needsAttentionCount > 0;

  const label =
    props.countStatus === 'loading' ? (
      <Skeleton width={110} />
    ) : (
      pluralize(props.needsAttentionCount, {
        singular: 'needs attention',
        plural: 'need attention',
      })
    );

  return (
    <Chip
      clickable
      icon={hasNeedsAttentionCount ? <WarningStatusIcon /> : undefined}
      color={hasNeedsAttentionCount ? 'warning' : 'default'}
      variant={props.isActive ? 'filled' : 'outlined'}
      label={label}
      onClick={props.onClick}
      onDelete={props.isActive ? props.onClick : undefined}
      aria-pressed={props.isActive}
    />
  );
}
